export default function TrustBadges() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-14 lg:gap-20">
            {/* Left - Label + Description */}
            <div className="lg:w-1/3">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                Verified &amp; Updated Daily
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                Looking for the <strong className="text-foreground-950">best Kakobuy Spreadsheet</strong>?
                Our spreadsheet helps buyers find verified products, compare sellers, save money,
                and shop safely through Kakobuy. Updated every week with the latest sneakers,
                clothing, accessories, and designer items.
              </p>
            </div>

            {/* Right - Stats Grid */}
            <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-8 md:gap-10">
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-1">
                  10,000<span className="text-primary-500">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600">Verified Products</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-1">
                  500<span className="text-primary-500">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600">Trusted Sellers</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-1">
                  98<span className="text-primary-500">%</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600">QC Pass Rate</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-1">
                  24/7
                </p>
                <p className="text-xs md:text-sm text-foreground-600">Live Updates</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}